var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
var IntroForm = function (_a) {
    var description = _a.description, descriptionColor = _a.descriptionColor, descriptionBackgroundColor = _a.descriptionBackgroundColor;
    return (_jsx(Wrap, { children: _jsx(IntroBox, __assign({ descriptionColor: descriptionColor, descriptionBackgroundColor: descriptionBackgroundColor }, { children: description })) }));
};
export default IntroForm;
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var IntroBox = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 95vw;\n  min-height: 10em;\n  padding: 50px;\n  color: ", ";\n  background-color: ", ";\n  border-radius: 10px;\n  display: grid;\n  align-items: center;\n  box-shadow: 0px 2px 5px 2px rgba(0, 0, 0, 0.1);\n"], ["\n  width: 95vw;\n  min-height: 10em;\n  padding: 50px;\n  color: ", ";\n  background-color: ", ";\n  border-radius: 10px;\n  display: grid;\n  align-items: center;\n  box-shadow: 0px 2px 5px 2px rgba(0, 0, 0, 0.1);\n"])), function (_a) {
    var descriptionColor = _a.descriptionColor;
    return descriptionColor;
}, function (_a) {
    var descriptionBackgroundColor = _a.descriptionBackgroundColor;
    return descriptionBackgroundColor;
});
var templateObject_1, templateObject_2;
